import { Dispatch, SetStateAction, useEffect } from "react";
import { useSendSyncOnlineCommandMutation } from "redux/RTQ/IlenkradApi";
import { ToastDanger } from "utils/toast/Toast";

interface IPropsUseSendCommand {
  command: string;
  name: string;
  imei: string;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  handleValues: (arg0: string) => void;
  open: boolean;
  trigger: number;
  sendSms: (arg0: string) => void;
  online: boolean;
}

const SendCommand = ({
  command,
  name,
  imei,
  setIsLoading,
  handleValues,
  open,
  sendSms,
  trigger,
  online,
}: IPropsUseSendCommand) => {
  const [mutateSync] = useSendSyncOnlineCommandMutation();

  useEffect(() => {
    if (trigger > 0) {
      setIsLoading(true);
      checkForSendType();
    }
  }, [trigger]);

  const checkForSendType = async () => {
    const body = {
      tracker_imei: imei,
      command: command,
      name: name,
      timeout: 10000,
      send_to_chat: true,
    };
    console.log("sending command sync", body);
    let sendType = localStorage.getItem("commandSendType");

    if (!sendType) sendType = "0";
    if (sendType === "0" && !online) {
      ToastDanger("ردیاب به اینترنت متصل نمیباشد.");
      sendType = "2";
    }

    if (sendType === "2") {
      setIsLoading(false);
      sendSms(command);
      return;
    }

    try {
      const response: any = await mutateSync(body);
      setIsLoading(false);
      if (response?.data?.online_command?.response) {
        handleValues(response.data.online_command.response);
      } else if (response?.data?.online_command?.response_status === "timeout") {
        sendSms(command);
        ToastDanger("پاسخی از ردیاب دریافت نشد (پایان مهلت زمانی)");
      } else if (response?.error) {
        sendSms(command);
        ToastDanger("خطا در ارسال دستور");
      } else {
        ToastDanger("پاسخی از ردیاب دریافت نشد.");
      }
    } catch {
      setIsLoading(false);
      sendSms(command);
      ToastDanger("خطا در ارتباط با سامانه");
    }
  };

  return null;
};

export default SendCommand;
